import React from "react"
import Ajax from "superagent"
import Carousel from 'nuka-carousel'
import "./CarPicker.less"
import {keyBy, values, isNumber} from "lodash"
import {Toast, Form} from "react-weui"
import { Plus, Minus } from "react-feather"
import DatePicker from './datePicker'

const cat = [
  // #WARNING hardcoded tag ids D:
  {label: "打车", tag: "NOW", }, 
  {label: "预订", tag: "LATER", }, 
]

export default class CarPicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      buyMode: "buyNow",
      countcars: 1,
      CarsToRender: [],
      type: "",
      priceeuro: "",
      priceyuan: "",
      picker_value: '',
      picker_show: false,
    }
  }

  componentDidMount() {
    Ajax
      .get(`/getRate?vendor=${this.props.userInfo.vendor}`)
      .then(res => this.setState({rate: res.body.rate}))

    if (this.props.originCoords && this.props.destinationCoords) {
      Ajax
        .post(`/uberapi/getAvailableProducts`)
        .send({ originCoords: this.props.originCoords, destinationCoords: this.props.destinationCoords})
        .then(res => {
          const preparedData = {
            AllProducts: keyBy(res.body.AllProducts, 'product_id'),
            AvailableProducts: keyBy(res.body.AvailableProducts, 'product_id'),
            EstimatedPrices: keyBy(res.body.EstimatedPrices, 'product_id'),
            RealProducts: keyBy(res.body.RealProducts, 'product_id'),
          }
          
          // const CarsToRender = values(preparedData.AllProducts)
          //   .filter(pr => (this.props.carMode == "NOW" ? preparedData.AvailableProducts[pr.product_id] : true))
          
          const CarsToRender = this.props.carMode == "NOW" 
            ? values(preparedData.AllProducts).filter(pr => preparedData.AvailableProducts[pr.product_id])
            : values(preparedData.AllProducts)
          
          this.setState(
            {
              ...preparedData,
              CarsToRender,
              selectedCar: CarsToRender[0]
            }
          )
          this.props.carOnChange(
            CarsToRender[0], 
            this.state.countcars,
            this.props.carMode == "NOW" ? this.getNowEurPrice(CarsToRender[0]) : this.getEstimatedEurPrice(CarsToRender[0])
          )
        })
    }
    else this.props.push(`/catalogo/${this.props.city}/transportation`)
  }

  eur2yuan(e) { return isNumber(e) ? e * this.state.rate : 0 }

  getNowEurPrice(product, countcars = this.state.countcars) {
    return (this.state.RealProducts[product.product_id].fare.value + 2) * countcars
  }

  getEstimatedEurPrice(product, countcars = this.state.countcars) {
    return (this.state.EstimatedPrices[product.product_id].high_estimate + 2) * countcars
  }
  
  getPrice(product, countcars = this.state.countcars) {
    return (this.props.carMode == "NOW")
      ? this.getNowEurPrice(product, countcars)
      : this.getEstimatedEurPrice(product, countcars)
  }

  renderPrice(product) {
    return (
      <div className="contentPrice">

        <div className="circle">&nbsp;</div>
        <div className="circle">&nbsp;</div>
        <div className="circle">&nbsp;</div>
        <div className="circle">&nbsp;</div>

        <div className="left">
          <div className="unidades">
            €{(this.getPrice(product)).toFixed(2).split(".")[0]}.
          </div>

          <div className="decimales">
            {(this.getPrice(product)).toFixed(2).split(".")[1]}
          </div>
        </div>

        <div className="right">          
          <div className="unidades">
            ¥{(this.eur2yuan(this.getNowEurPrice(product))).toFixed(2).split(".")[0]}.
          </div>

          <div className="decimales">
            {(this.eur2yuan(this.getNowEurPrice(product))).toFixed(2).split(".")[1]}
          </div>        
        </div>

      </div>
    )
  }

  render() {
    return (
      <div className="car-pick2-page">
        <div className="twobuttons-stand-in">
          &nbsp;
        </div>
        <div className="twobuttons">
          <div>&nbsp;</div><div>&nbsp;</div>
          {
            cat.map(({tag, label}) => (
              <button
                key={tag}
                className={this.props.carMode == tag ? "active" : ""}
                onClick={() => {
                  this.setState({ carMode: tag, picker_show: !this.props.picker_value })
                  this.props.carModeChange(tag)
                  this.props.priceOnChange(tag == "NOW" ? this.getNowEurPrice(this.state.selectedCar) : this.getEstimatedEurPrice(this.state.selectedCar))
                }}
              >
                {label}
              </button>
            ))
          }
          <div>&nbsp;</div><div>&nbsp;</div>
        </div>
        
        {
          this.state.CarsToRender.length == 0 && (
            <Toast icon="loading" show>Getting cars...</Toast>
          )
        }
        
        {
          this.state.CarsToRender.length > 0 && (
            <Carousel
              swiping
              withoutControls
              slidesToShow={1.14}
              cellAlign={"center"}
              afterSlide={slideIndex => {
                const selectedCar = this.state.CarsToRender[slideIndex]
                this.setState({selectedCar, slideIndex})
                this.props.carOnChange(
                  selectedCar, 
                  this.state.countcars,
                  this.props.carMode == "NOW" ? this.getNowEurPrice(selectedCar) : this.getEstimatedEurPrice(selectedCar)
                ) 
              }}
            >
              {this.state.CarsToRender.map((product, i) => (
                <React.Fragment key={product.product_id}>

                  <div className="info-content"
                    onClick={() => {
                      this.setState({
                        type: product.display_name,
                        priceeuro: (this.state.RealProducts[product.product_id].fare.value + 2).toFixed(2) * this.state.countcars,
                        priceyuan: this.eur2yuan(this.state.RealProducts[product.product_id].fare.value + 2).toFixed(2) * this.state.countcars
                      })
                    }}
                  >

                    <div className="tipo">
                      <p className="tipo-esp">{product.display_name}</p>
                      <p className="tipo-ch">{product.description}</p>
                      <p className="tipo-ch">{product.capacity * this.state.countcars}乘客</p>
                    </div>
                    {
                      product.display_name == "Black" && <div className="car-image uberblack"></div>
                    }

                    {
                      product.display_name == "UberX" && <div className="car-image uberx"></div>
                    }
                    {
                    
                      <div className="detalles">
                        <div className="detalle">
                          <button 
                            style={{color: this.state.countcars < 2 ? "#666666" : ""}}
                            disabled={this.state.countcars < 2}
                            className="minus"
                            onClick={() => {
                              const newCount = this.state.countcars - 1
                              this.setState({
                                countcars:newCount
                              })
                              this.props.carOnChange(
                                product, 
                                newCount,
                                this.props.carMode == "NOW" ? this.getNowEurPrice(product, newCount) : this.getEstimatedEurPrice(product, newCount)
                              )
                            }}
                          >
                            <Minus />
                          </button>
                        </div>
                        <div className="detalle countcars">
                          {this.state.countcars}
                        </div>
                        <div className="detalle" >
                          <button 
                            className="plus"
                            onClick={() => {
                              const newCount = this.state.countcars + 1
                              this.setState({
                                countcars:newCount
                              })
                              this.props.carOnChange(
                                product, 
                                newCount,
                                this.props.carMode == "NOW" ? this.getNowEurPrice(product, newCount) : this.getEstimatedEurPrice(product, newCount)
                              )
                            }}
                          >
                            <Plus />
                          </button>
                        </div>
                      </div>

                    }
                    <div className="precio">
                      {this.renderPrice(product)}
                    </div>                     
                    {this.props.carMode == "LATER" && (
                      <Form>
                        <DatePicker
                          days={3 * 30}
                          onChange={(date, picker_value) => {
                            this.props.onTimeSelected(date, picker_value)
                          }}
                          showChange={picker_show => this.setState({picker_show})}
                          warn={null}
                          picker_value={this.props.picker_value}
                          picker_show={this.state.picker_show}
                        />
                      </Form>)}

                  </div>
                </React.Fragment>
              ))}
            </Carousel>
          ) 
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/CarPicker.jsx